import React from "react";
import PropTypes from "prop-types";

const Filtering = ({
  certifications,
  certification,
  locations,
  location,
  onChangeCertification,
  onChangeLocation
}) => (
  <div className="row">
    <div className="col-md-3 col-xs-12">
      <select
        className="form-control"
        value={location}
        onChange={onChangeLocation}
      >
        <option value="">All My Locations</option>

        {locations.map(item => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
    </div>

    <div className="col-md-3 col-xs-12">
      <select
        className="form-control"
        value={certification}
        onChange={onChangeCertification}
      >
        <option value="">All Certifications</option>

        {certifications.map(item => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
    </div>
  </div>
);

Filtering.propTypes = {
  certifications: PropTypes.array.isRequired,
  certification: PropTypes.string.isRequired,
  locations: PropTypes.array.isRequired,
  location: PropTypes.string.isRequired,
  onChangeCertification: PropTypes.func.isRequired,
  onChangeLocation: PropTypes.func.isRequired
};

export default Filtering;
